import { Box, circularProgressClasses } from "@mui-wrapper";
import { CircularProgress, Text } from "@flat-ui";
import { useMemo } from "react";
/** Default size (height and width) of the circular progress in pixels */
const CIRCULAR_PROGRESS_SIZE = 60;

/** Default thickness for the circular progress, it is unitless and refers to CircularProgress thickness */
const CIRCULAR_PROGRESS_THICKNESS = 4;

/** Render a circular progress spinner with progress value if provided */
export function SphereCircularProgress({
  value,
  maxValue,
  label,
  unit,
  shouldHideValue,
  size,
  thickness,
  sxValue,
  strokeLinecap = "round",
  color
}) {
  const circleSize = useMemo(() => {
    return `${size ?? CIRCULAR_PROGRESS_SIZE}px`;
  }, [size]);
  const indicatorThickness = useMemo(() => {
    return thickness ?? CIRCULAR_PROGRESS_THICKNESS;
  }, [thickness]);
  const indicatorUnit = useMemo(() => {
    return typeof unit === "string" ? unit : "%";
  }, [unit]);
  const indicatorValue = useMemo(() => {
    if (value === undefined) {
      return undefined;
    }
    return value > 0 ? value : 0;
  }, [value]);
  const progress = useMemo(() => {
    if (indicatorValue === undefined) {
      return;
    }
    const indicatorMaxValue = maxValue ?? 100;
    if (indicatorValue > indicatorMaxValue) {
      return 100;
    }
    return indicatorValue / indicatorMaxValue * 100;
  }, [maxValue, indicatorValue]);
  return <Box data-testid="sphere-circular-progress">
      <Box sx={{
      position: "relative",
      height: circleSize,
      width: circleSize
    }}>
        <CircularProgress variant={typeof indicatorValue !== "undefined" ? "determinate" : "indeterminate"} color={color ? "inherit" : "primary"} sx={{
        ...(color && {
          color
        }),
        [`& .${circularProgressClasses.circle}`]: {
          strokeLinecap: strokeLinecap === "round" ? "round" : "butt"
        }
      }} size={circleSize} thickness={indicatorThickness} value={progress} />
        {typeof indicatorValue !== "undefined" && !shouldHideValue && <Box data-testid="sphere-circular-progress-value" sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
            <Text variant="bodyS" component="div" sx={{
          ...sxValue,
          color: "text.primary"
        }}>{`${Math.round(indicatorValue)}${indicatorUnit}`}</Text>
          </Box>}
      </Box>

      {label && <Text data-testid="sphere-circular-progress=label" variant="bodyS" component="div" sx={{
      paddingTop: "10px",
      color: "text.primary"
    }}>
          {label}
        </Text>}
    </Box>;
}